import React from "react";
import { Container } from "./Styled";
import logo from "assets/images/fuelops-full.svg";

export const Header: React.FC<{ data: any; showAddress: boolean }> = ({
  data: { dealerInfo },
  showAddress,
}) => {
  const { address1, city, dealername, phoneNumber, state, zip } = dealerInfo;
  return (
    <Container>
      <div id="fuelops__po-title">
        <img src={logo} alt="FuelOps Logo" />
        <h3>Fuel Purchase Voucher</h3>
      </div>
      {showAddress && (
        <div id="fuelops__dealership-info">
          <ul>
            <li>{dealername}</li>
            <li>{address1}</li>
            <li>
              {city}, {state} {zip}
            </li>
            <li>{phoneNumber}</li>
          </ul>
        </div>
      )}
    </Container>
  );
};
